function s(r) {
  var a;
  return a = class extends r {
    static create(e) {
      const t = super.create(e);
      if (typeof e == "boolean" && e)
        return t;
      const n = document.createElement("img");
      return n.setAttribute("src", e), t.appendChild(n), t;
    }
    static value(e) {
      const { src: t, custom: n } = e.dataset;
      return { src: t, custom: n };
    }
    deleteAt(e, t) {
      super.deleteAt(e, t), this.cache = {};
    }
  }, a.blotName = "imageBlot", a.className = "ql-image-uploading", a.tagName = "span", a;
}
export {
  s as createImageBlot
};
